import UserIcon from '@mui/icons-material/Group';

import UserList from './UserList';

import { CreateUser } from './CreateUser';

export default {
      list: UserList,
      create: CreateUser,
      icon: UserIcon,
}